import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-add-portal-builder',
  templateUrl: './add-portal-builder.component.html',
  styleUrls: ['./add-portal-builder.component.css']
})
export class AddPortalBuilderComponent  implements OnInit {

  portalBuilderForm!: FormGroup;

  cards = [
    {
      heading: 'Header Logo',
      logo: '../../assets/image/logo.png',
      button: 'Upload',
      type: 'Hlogo',
    },
    {
      heading: 'Footer  Logo',
      logo: '../../assets/image/logo.png',
      button: 'Upload',
      type: 'Flogo',
    },
    {
      heading: 'Favicon',
      logo: '../../assets/image/logo.png',
      button: 'Upload',
      type: 'Favlogo',
    },
  ];

  languageList = [
    { _id: 'en', title: 'English' },
    { _id: 'fr', title: 'French' },
    // Add more languages if needed
  ];

  showSkip = true;
  roleId = 'admin'; // Set this dynamically as needed
  selectedColor = '#000000';
  selectedSecoundaryColor = '#ffffff';
  colors = [
    { colorCode: '#FF5733' },
    { colorCode: '#33FF57' },
    { colorCode: '#3357FF' },
    { colorCode: '#FFD700' },
    { colorCode: '#8A2BE2' },
    // Add more colors if needed
  ];

  themeLookText = '';

  // systemSettingsForm!: FormGroup;

  currencyData = [
    { _id: 'usd', title: 'USD - US Dollar' },
    { _id: 'eur', title: 'EUR - Euro' },
    { _id: 'inr', title: 'INR - Indian Rupee' },
    // Add more currencies here
  ];

  currencySymbolData = [
    { symbol: '$' },
    { symbol: '€' },
    { symbol: '₹' },
    // Add more symbols here
  ];

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '200px',
    placeholder: 'Enter bank notice content here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      ['subscript', 'superscript'],
      ['insertVideo']
    ]
  };

  bankSettingForm = [
    { heading: 'Bank Name', formControlName: 'bankName', placeholder: 'Enter Bank Name', errorMsg: 'Bank Name is required' },
    { heading: 'Branch Name', formControlName: 'branchName', placeholder: 'Enter Branch Name', errorMsg: 'Branch Name is required' },
    { heading: 'Telephone', formControlName: 'telephone', placeholder: 'Enter Telephone', errorMsg: 'Telephone is required' },
    { heading: 'Zip/Post Code', formControlName: 'zipCode', placeholder: 'Enter Zip/Post Code', errorMsg: 'Zip Code is required' },
  ];
  
  stateData = [
    { _id: '1', title: 'Karnataka' },
    { _id: '2', title: 'Maharashtra' }
  ];
  
  cityData = [
    { _id: '1', title: 'Bangalore' },
    { _id: '2', title: 'Mumbai' }
  ];
  payOutTableData = [
    {
      range: '0 - 1000',
      rangeChargeType: 'chargeTypeOne',
      rangeChargePartner: 'chargePartnerOne'
    },
    {
      range: '1001 - 5000',
      rangeChargeType: 'chargeTypeTwo',
      rangeChargePartner: 'chargePartnerTwo'
    },
    {
      range: '5001 and above',
      rangeChargeType: 'chargeTypeThree',
      rangeChargePartner: 'chargePartnerThree'
    }
  ];
  selectedFileHlogo: any;
  selectedFileFlogo: any;
  selectedFileFavlogo: any;


  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.portalBuilderForm = this.fb.group({
      title: ['', Validators.required],
      defaultLanguage: ['', Validators.required],
      news: [''],
      billNotice: [''],
      currency: [''],
      currencySymbol: [''],
      bankNotice: [''],
      bankName: ['', Validators.required],
  branchName: ['', Validators.required],
  telephone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
  zipCode: ['', [Validators.required, Validators.maxLength(6)]],
  country: ['', Validators.required],
  state: ['', Validators.required],
  city: ['', Validators.required],
  bankTimeZone: ['', Validators.required],
  supportContactNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
  supportContactEmail: ['', [Validators.required, Validators.email]],
  chargeType: ['', Validators.required],
  payInPartner: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
  chargeTypeOne: ['', Validators.required],
  chargePartnerOne: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
  chargeTypeTwo: ['', Validators.required],
  chargePartnerTwo: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
  chargeTypeThree: ['', Validators.required],
  chargePartnerThree: ['', [Validators.required, Validators.min(0), Validators.max(100)]]

      
    });

    // this.systemSettingsForm = this.fb.group({
    //   currency: [''],
    //   currencySymbol: ['']
    // });
  }

  // 📁 Handle File Upload
  onFileSelected(event: any, type: string): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const card = this.cards.find(c => c.type === type);
        if (card) {
          card.logo = result;
        }
      };
      reader.readAsDataURL(file);
    }
  }
  // onFileSelected(event: any, type: any) {
  //   if (type == 'Hlogo') {
  //     this.selectedFileHlogo = event.target.files[0];
  //     this.cards[0].logo = URL.createObjectURL(this.selectedFileHlogo);
  //     // this.uploadImgAPI(
  //     //   this.selectedFileHlogo?.type,
  //     //   this.folderName,
  //     //   this.selectedFileHlogo,
  //     //   'Hlogo'
  //     // );
  //   }
  //   if (type == 'Flogo') {
  //     this.selectedFileFlogo = event.target.files[0];
  //     this.cards[1].logo = URL.createObjectURL(this.selectedFileFlogo);
  //     // this.uploadImgAPI(
  //     //   this.selectedFileFlogo?.type,
  //     //   this.folderName,
  //     //   this.selectedFileFlogo,
  //     //   'Flogo'
  //     // );
  //   }
  //   if (type == 'Favlogo') {
  //     this.selectedFileFavlogo = event.target.files[0];
  //     this.cards[2].logo = URL.createObjectURL(this.selectedFileFavlogo);
  //     // this.uploadImgAPI(
  //     //   this.selectedFileFlogo?.type,
  //     //   this.folderName,
  //     //   this.selectedFileFavlogo,
  //     //   'Favlogo'
  //     // );
  //   }
  // }

  // 🌐 Language Change Handler
  onLanguageSelect(event: any): void {
    const value = (event.target as HTMLSelectElement).value;
    this.portalBuilderForm.patchValue({ defaultLanguage: value });
  }

  // 🎨 Color Change Handlers
  onPrimeryColorChange(color: string): void {
    this.selectedColor = color;
    this.setThemePreview();
  }

  onSecondaryColorChange(color: string): void {
    this.selectedSecoundaryColor = color;
    this.setThemePreview();
  }

  // 🎨 Theme Preview Message
  setThemePreview(): void {
    this.themeLookText = `You selected primary color: ${this.selectedColor} and secondary color: ${this.selectedSecoundaryColor}`;
  }

  // 🛡️ Submit Handler (Optional)
  onSubmit(): void {
    if (this.portalBuilderForm.valid) {
      const formValues = this.portalBuilderForm.value;
      console.log('Form submitted:', formValues);
      // Perform save or update logic
    } else {
      this.portalBuilderForm.markAllAsTouched();
    }
  }

//Currency
  onCurrencySelect(event: any): void {
    const selectedCurrencyId = event.value;
    console.log('Selected Currency ID:', selectedCurrencyId);

    // Optional: auto-select corresponding symbol
    const matched = this.currencySymbolData.find(sym =>
      selectedCurrencyId.toLowerCase().includes(sym.symbol.toLowerCase())
    );
    if (matched) {
      this.portalBuilderForm.patchValue({ currencySymbol: matched.symbol });
    }
  }
  keyPressNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }
  
  onCountrySelect(event: any) {
    console.log('Selected Country:', event.value);
  }
  
  onStateSelect(event: any) {
    console.log('Selected State:', event.value);
  }
  
  onCitySelect(event: any) {
    console.log('Selected City:', event.value);
  }

  createPortalBuilder(): void {
    if (this.portalBuilderForm.valid) {
      // Handle form submission logic here
      console.log('Form Submitted', this.portalBuilderForm.value);

      // You can reset the form after submission if needed
      this.portalBuilderForm.reset();
    } else {
      // Display an error message if the form is invalid
      console.log('Form is invalid');
    }
  }
}